export const SESSION_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

export const withSessionExpiry = (user) => ({
  ...user,
  expiresAt: Date.now() + SESSION_DURATION_MS,
});

export const getValidStoredUser = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;

    const user = JSON.parse(raw);
    if (!user?.token) {
      localStorage.removeItem('user');
      return null;
    }

    if (!user.expiresAt) {
      user.expiresAt = Date.now() + SESSION_DURATION_MS;
      localStorage.setItem('user', JSON.stringify(user));
    }

    if (Date.now() > user.expiresAt) {
      localStorage.removeItem('user');
      return null;
    }

    return user;
  } catch {
    localStorage.removeItem('user');
    return null;
  }
};
